module.exports = __webpack_public_path__ + "media/images/vehicles/betonpumpe-f200ba6185a4cce66452cc53d76b8c24.png";